import React, { Component } from 'react';
import { debugLog } from '../../../util/logUtils';
import './scss/PhoneNumber.scss';

class PhoneNumber extends Component {
	constructor(props) {
		super(props);

		const countryList = props.countryList || [];
		let selectedDial = null;
		countryList.map((item) => {
			selectedDial = item.active ? item.dial_code : selectedDial;
			return false;
		});

		this.state = {
			countryList: props.countryList,
			dial_code: selectedDial,
			phone: this.props.initialPhone,
		};

		this.handleOnChange = this.handleOnChange.bind(this);
		this.handleOnPhoneChange = this.handleOnPhoneChange.bind(this);
	}

	// this will be called via ref from outside the comp to reset the value.
	resetPhoneNumber = () => {
		debugLog('calling reset:',this.state.phone);
		this.setState({
			phone: ''
		},() => {
		debugLog('calling reset:',this.state.phone);

		});
	}

	handleOnPhoneChange(event) {
		const value = event.target.value;
		this.setState({ phone: value }, () => {
			if (this.props.onPhoneChange) {
				this.props.onPhoneChange(value);
			}
		});
		
	}
	handleOnChange(event) {
		const value = event.target.value;
		this.setState({ dial_code: value }, () => {
			if (this.props.onSelectChange) {
				this.props.onSelectChange(value);
			}
		});
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.initialPhone !== prevProps.initialPhone) {
			debugLog('updated prop phone ' + this.props.initialPhone);
			this.setState({
				phone: this.props.initialPhone
			})
		}
	}

	componentDidMount() {
		this.props.onSelectChange(this.state.dial_code);
	}

	render() {

		const props = this.props,
			state = this.state || {},
			id = props.id || '',
			labelPhoneNumber = props.label || '',
			meta = props.meta || {},
			canShowDialCode = meta.hasOwnProperty('canShowDialCode') ? (meta.canShowDialCode || false) : true,
			style = meta.style || '',
			phoneNumberStyleClass = canShowDialCode ? 'phno-input-container' : 'full-width-phone-txt'; // default value is true because except bbd all other api will not have this meta

		debugLog("phn:", meta);
		return (
			<div id={id} className="phone-number input-group">
				{canShowDialCode && <select
					className={"custom-select custom-select-lg vt-select input-group-prepend " + style}
					onChange={this.handleOnChange}
					defaultValue={state.dial_code}
					disabled={props.restrictValueChange ? true : false}>

					{state.countryList && state.countryList.map((item, index) => {
						return (
							<option key={index} value={item.dial_code}>
								{item.country_name} ({item.dial_code})
							</option>
						);
					})}
				</select>}
				<div className={phoneNumberStyleClass}>
					<label htmlFor="inputPhone" className="sr-only">{labelPhoneNumber}</label>
					<input
						type="phone"
						id="inputPhone"
						name='phone'
						className="vt-input form-control transparent-txt"
						placeholder={labelPhoneNumber}
						value={this.state.phone}
						onChange={this.handleOnPhoneChange}
						disabled={props.restrictValueChange ? true : false} />
				</div>
			</div>
		);
	}
}

export default PhoneNumber;
